var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLgCircled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.7998,
    cy: 50,
    r: 49.5,
    stroke: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8215 15.5715C31.8529 15.5715 16.5137 30.9536 16.5137 49.879C16.5137 68.8038 31.8529 84.1429 50.8215 84.1429C69.7471 84.1429 85.0851 68.8044 85.0851 49.879C85.0851 30.9536 69.7471 15.5715 50.8215 15.5715ZM38.2047 33.2005C40.4515 33.2005 42.3095 35.0584 42.3095 37.3047C42.3095 39.5945 40.4515 41.4531 38.2047 41.4531C37.1046 41.4526 36.0498 41.0154 35.272 40.2375C34.4942 39.4596 34.0571 38.4047 34.0568 37.3047C34.0568 35.0584 35.9148 33.2005 38.2047 33.2005ZM54.3648 66.3843H49.5257V34.0649H52.7231V63.1439H59.2038V66.3849L54.3648 66.3843ZM54.3648 76.6245C66.5061 75.0258 76.0988 65.3035 77.5672 53.1193H59.2038V49.7487H80.5053C80.5053 64.9146 69.0989 77.5749 54.3648 79.3899C53.198 79.5201 51.9883 79.5625 50.8215 79.5625C46.2847 79.5625 42.0066 78.5684 38.2047 76.7977C28.094 72.0447 21.0511 61.7609 21.0511 49.879C21.0511 37.9965 28.094 27.7132 38.2047 22.9602C41.834 21.2749 45.8958 20.2815 50.1733 20.1518V22.9172C45.9949 23.0004 41.8948 24.0661 38.2047 26.0279C29.6497 30.5647 23.8165 39.5521 23.8165 49.879C23.8165 60.2058 29.6497 69.1933 38.2047 73.7294C41.9642 75.717 46.2417 76.8401 50.8215 76.8401C51.9883 76.8401 53.198 76.7535 54.3648 76.6245Z",
    fill: "#2D2F35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgCircled);
export default __webpack_public_path__ + "static/media/lg-circled.f786521a4c8cf154c40b1185846af840.svg";
export { ForwardRef as ReactComponent };